export const CameraSparkleIcon = () => (
  <svg
    width="33"
    height="25"
    viewBox="0 0 33 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.0846 24.9793H18.7619C19.908 24.9793 20.8465 24.0674 20.8465 22.9542V13.8413C20.8465 12.7279 19.9078 11.8163 18.7619 11.8163H16.2598C15.9159 11.8163 15.5454 11.5574 15.4373 11.2399L14.7901 9.35492C14.6811 9.03758 14.3117 8.7785 13.9676 8.7785H6.8789C6.53497 8.7785 6.16443 9.03736 6.0564 9.35492L5.40913 11.2399C5.30017 11.5572 4.9308 11.8163 4.58663 11.8163H2.0846C0.938467 11.8163 0 12.7282 0 13.8413V22.9542C0 24.0674 0.938467 24.9793 2.0846 24.9793ZM18.032 13.6135C18.5642 13.6135 18.9954 14.0326 18.9954 14.5481C18.9954 15.0651 18.564 15.484 18.032 15.484C17.5012 15.484 17.0686 15.0649 17.0686 14.5481C17.0686 14.0324 17.5012 13.6135 18.032 13.6135ZM10.4232 12.7406C13.3856 12.7406 15.7871 15.0735 15.7871 17.9513C15.7871 20.8292 13.3856 23.1621 10.4232 23.1621C7.46083 23.1621 5.05937 20.8292 5.05937 17.9515C5.05937 15.0735 7.46083 12.7406 10.4232 12.7406Z"
      fill="white"
    />
    <path
      d="M10.4232 20.5298C11.8892 20.5298 13.0776 19.3753 13.0776 17.9512C13.0776 16.5271 11.8892 15.3727 10.4232 15.3727C8.95724 15.3727 7.76883 16.5271 7.76883 17.9512C7.76883 19.3753 8.95724 20.5298 10.4232 20.5298Z"
      fill="white"
    />
    <path
      d="M29.9095 11.4605C29.6323 11.5578 29.3806 11.7173 29.1732 11.9269C28.9657 12.1366 28.808 12.391 28.7117 12.671L28.3477 13.7296C28.3453 13.7377 28.3404 13.7449 28.3337 13.7499C28.327 13.755 28.3188 13.7577 28.3104 13.7577C28.302 13.7577 28.2939 13.755 28.2872 13.7499C28.2804 13.7449 28.2755 13.7377 28.2732 13.7296L27.91 12.671C27.8137 12.3909 27.6558 12.1364 27.4482 11.9268C27.2406 11.7171 26.9887 11.5577 26.7114 11.4605L25.6644 11.0928C25.6567 11.0901 25.6501 11.0851 25.6454 11.0784C25.6408 11.0718 25.6382 11.0638 25.6382 11.0557C25.6382 11.0475 25.6408 11.0395 25.6454 11.0329C25.6501 11.0262 25.6567 11.0212 25.6644 11.0186L26.7114 10.6508C26.9887 10.5536 27.2406 10.3943 27.4482 10.1846C27.6558 9.97493 27.8137 9.72044 27.91 9.44029L28.2732 8.38172C28.2755 8.37359 28.2804 8.36646 28.2872 8.36138C28.2939 8.35631 28.302 8.35358 28.3104 8.35358C28.3188 8.35358 28.327 8.35631 28.3337 8.36138C28.3404 8.36646 28.3453 8.37359 28.3477 8.38172L28.7117 9.44029C28.808 9.72035 28.9657 9.97475 29.1732 10.1844C29.3806 10.3941 29.6323 10.5535 29.9095 10.6508L30.9574 11.0186C30.965 11.0212 30.9716 11.0262 30.9763 11.0329C30.981 11.0395 30.9835 11.0475 30.9835 11.0557C30.9835 11.0638 30.981 11.0718 30.9763 11.0784C30.9716 11.0851 30.965 11.0901 30.9574 11.0928L29.9095 11.4605Z"
      fill="white"
    />
    <path
      d="M30.7548 3.88214C30.4084 4.00376 30.0937 4.20309 29.8344 4.46516C29.5751 4.72722 29.3779 5.04523 29.2575 5.39532L28.8026 6.71856C28.7994 6.72838 28.7932 6.73691 28.7849 6.74297C28.7767 6.74903 28.7667 6.75231 28.7565 6.75231C28.7462 6.75231 28.7363 6.74903 28.728 6.74297C28.7197 6.73691 28.7135 6.72838 28.7103 6.71856L28.2554 5.39532C28.135 5.04521 27.9378 4.72719 27.6784 4.46512C27.4191 4.20306 27.1044 4.00374 26.7579 3.88214L25.4485 3.42251C25.439 3.41916 25.4308 3.4129 25.4249 3.40459C25.4191 3.39628 25.4159 3.38633 25.4159 3.37614C25.4159 3.36594 25.4191 3.35603 25.4249 3.34773C25.4308 3.33942 25.439 3.33312 25.4485 3.32977L26.7579 2.87013C27.1044 2.74854 27.4191 2.54926 27.6784 2.28719C27.9378 2.02513 28.135 1.70711 28.2554 1.357L28.7103 0.0337568C28.7135 0.023936 28.7197 0.0153663 28.728 0.00930426C28.7363 0.00324221 28.7462 0 28.7565 0C28.7667 0 28.7767 0.00324221 28.7849 0.00930426C28.7932 0.0153663 28.7994 0.023936 28.8026 0.0337568L29.2575 1.357C29.3779 1.70709 29.5751 2.02509 29.8344 2.28716C30.0937 2.54922 30.4084 2.74851 30.7548 2.87013L32.0642 3.32977C32.0737 3.33312 32.082 3.33942 32.0878 3.34773C32.0937 3.35603 32.0968 3.36594 32.0968 3.37614C32.0968 3.38633 32.0937 3.39628 32.0878 3.40459C32.082 3.4129 32.0737 3.41916 32.0642 3.42251L30.7548 3.88214Z"
      fill="white"
    />
    <path
      d="M24.9979 8.01076C24.5168 8.1797 24.0797 8.45652 23.7196 8.8205C23.3594 9.18448 23.0855 9.62619 22.9184 10.1124L22.2863 11.9502C22.2818 11.9637 22.2732 11.9754 22.2618 11.9837C22.2503 11.992 22.2366 11.9965 22.2224 11.9965C22.2083 11.9965 22.1946 11.992 22.1831 11.9837C22.1717 11.9754 22.1631 11.9637 22.1586 11.9502L21.5265 10.1124C21.3594 9.62619 21.0855 9.18448 20.7253 8.8205C20.3652 8.45652 19.9281 8.1797 19.447 8.01076L17.6282 7.37238C17.615 7.36773 17.6035 7.35901 17.5954 7.34747C17.5873 7.33593 17.5829 7.32214 17.5829 7.30798C17.5829 7.29383 17.5873 7.28004 17.5954 7.2685C17.6035 7.25696 17.615 7.24824 17.6282 7.24358L19.447 6.6052C19.9281 6.43627 20.3652 6.15945 20.7253 5.79547C21.0855 5.43148 21.3594 4.98978 21.5265 4.50356L22.1586 2.66574C22.1631 2.65224 22.1717 2.64055 22.1831 2.63225C22.1946 2.62395 22.2083 2.61945 22.2224 2.61945C22.2366 2.61945 22.2503 2.62395 22.2618 2.63225C22.2732 2.64055 22.2818 2.65224 22.2863 2.66574L22.9184 4.50356C23.0855 4.98978 23.3594 5.43148 23.7196 5.79547C24.0797 6.15945 24.5168 6.43627 24.9979 6.6052L26.8167 7.24358C26.8299 7.24824 26.8414 7.25696 26.8495 7.2685C26.8576 7.28004 26.862 7.29383 26.862 7.30798C26.862 7.32214 26.8576 7.33593 26.8495 7.34747C26.8414 7.35901 26.8299 7.36773 26.8167 7.37238L24.9979 8.01076Z"
      fill="white"
    />
  </svg>
);

/**
 * macOS-style "toggle panels" glyph: a rounded window with a left sidebar
 * column. When `filled` the sidebar reads solid (panels shown); when not it
 * is an empty outline (panels hidden) — the same shape flips state, matching
 * the Finder show/hide-sidebar affordance. Uses currentColor so it inherits
 * the button's text color.
 */
export const PanelsIcon = ({ filled = true, size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="2.75"
      y="4.75"
      width="14.5"
      height="10.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="8"
      y1="5.5"
      x2="8"
      y2="14.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    {filled && (
      <path
        d="M5 4.75 H8 V15.25 H5 A2.25 2.25 0 0 1 2.75 13 V7 A2.25 2.25 0 0 1 5 4.75 Z"
        fill="currentColor"
      />
    )}
  </svg>
);

export const PenPaperIconCyan = () => (
  <svg
    width="26"
    height="26"
    viewBox="2 2 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.01127 3.12002C8.89194 3.13085 8.78004 3.18248 8.6944 3.26627L4.5344 7.42627C4.43461 7.52496 4.37892 7.65969 4.38002 7.80002V22.36C4.38002 22.4979 4.43486 22.6302 4.53236 22.7277C4.62986 22.8252 4.76214 22.88 4.90003 22.88H18.42C18.5579 22.88 18.6902 22.8252 18.7877 22.7277C18.8852 22.6302 18.94 22.4979 18.94 22.36V15.3643L23.3518 7.67804C23.8986 6.72538 23.5733 5.49815 22.6205 4.94804C22.5605 4.91359 22.4942 4.8915 22.4255 4.88304C22.2429 4.80187 22.0564 4.71952 21.8649 4.69616C21.0907 4.60162 20.295 4.96479 19.8824 5.67929L18.9399 7.30429V3.64002C18.9399 3.50215 18.8851 3.36986 18.7876 3.27236C18.6901 3.17486 18.5578 3.12002 18.4199 3.12002H9.05992C9.04367 3.11926 9.02742 3.11926 9.01117 3.12002L9.01127 3.12002ZM9.58002 4.16002H17.9V9.10002L12.7733 17.9318C12.7156 18.0269 12.69 18.138 12.7001 18.2487L12.9601 20.8487C12.9767 21.0152 13.0725 21.1636 13.2174 21.2474C13.3624 21.3311 13.5388 21.34 13.6914 21.2712L16.0314 20.2312C16.1341 20.1862 16.2197 20.1093 16.2751 20.0118L17.9001 17.176V21.8398H5.42013V8.3198H9.06013C9.198 8.3198 9.33029 8.26496 9.42779 8.16746C9.52529 8.06996 9.58013 7.93768 9.58013 7.79979L9.58002 4.16002ZM8.54002 4.89127V7.28002H6.15127L8.54002 4.89127ZM21.5968 5.7119C21.6431 5.71105 21.6884 5.71393 21.7349 5.72002C21.859 5.73636 21.9832 5.78231 22.1005 5.85002C22.5699 6.12103 22.7205 6.68681 22.4499 7.15815L21.613 8.61252L19.9474 7.63752L20.7843 6.1994C20.9621 5.89149 21.2729 5.71766 21.5968 5.7119ZM19.4275 8.5394L21.1013 9.5144L15.812 18.7362L14.1058 17.7043L19.4275 8.5394ZM7.71127 10.4C7.57331 10.4065 7.44364 10.4675 7.35063 10.5695C7.2577 10.6716 7.20903 10.8064 7.21555 10.9444C7.22198 11.0824 7.28301 11.212 7.38507 11.305C7.48723 11.398 7.62206 11.4466 7.76002 11.44H14.78C14.9192 11.442 15.0534 11.3881 15.1525 11.2903C15.2516 11.1926 15.3074 11.0593 15.3074 10.92C15.3074 10.7808 15.2516 10.6474 15.1525 10.5497C15.0534 10.452 14.9192 10.3981 14.78 10.4H7.76002C7.74377 10.3993 7.72752 10.3993 7.71127 10.4ZM7.71127 13C7.57331 13.0065 7.44364 13.0675 7.35063 13.1695C7.2577 13.2716 7.20903 13.4064 7.21555 13.5444C7.22198 13.6824 7.28301 13.812 7.38507 13.905C7.48723 13.998 7.62206 14.0466 7.76002 14.04H12.7C12.8392 14.042 12.9734 13.9881 13.0725 13.8903C13.1716 13.7926 13.2274 13.6593 13.2274 13.52C13.2274 13.3808 13.1716 13.2474 13.0725 13.1497C12.9734 13.052 12.8392 12.9981 12.7 13H7.76002C7.74377 12.9993 7.72752 12.9993 7.71127 13ZM7.71127 15.6C7.57331 15.6065 7.44364 15.6675 7.35063 15.7695C7.2577 15.8716 7.20903 16.0064 7.21555 16.1444C7.22198 16.2824 7.28301 16.412 7.38507 16.505C7.48723 16.598 7.62206 16.6466 7.76002 16.64H11.66C11.7992 16.642 11.9334 16.5881 12.0325 16.4903C12.1316 16.3926 12.1874 16.2593 12.1874 16.12C12.1874 15.9808 12.1316 15.8474 12.0325 15.7497C11.9334 15.652 11.7992 15.5981 11.66 15.6H7.76002C7.74377 15.5993 7.72752 15.5993 7.71127 15.6ZM7.71127 18.2C7.57331 18.2065 7.44364 18.2675 7.35063 18.3695C7.2577 18.4716 7.20903 18.6064 7.21555 18.7444C7.22198 18.8824 7.28301 19.012 7.38507 19.105C7.48723 19.198 7.62206 19.2466 7.76002 19.24H11.14C11.2792 19.242 11.4134 19.1881 11.5125 19.0903C11.6116 18.9926 11.6674 18.8593 11.6674 18.72C11.6674 18.5808 11.6116 18.4474 11.5125 18.3497C11.4134 18.252 11.2792 18.1981 11.14 18.2H7.76002C7.74377 18.1993 7.72752 18.1993 7.71127 18.2ZM13.797 18.7281L15.097 19.5081L13.927 20.0281L13.797 18.7281Z"
      fill="#00FFFF"
    />
  </svg>
);

export const CameraResetIcon = () => (
  <svg
    width="26"
    height="20"
    viewBox="0 0 21 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V3.10289L19.4553 0.209087C20.1206 -0.223019 21 0.254429 21 1.04771V12.9523C21 13.7456 20.1206 14.223 19.4553 13.7909L15 10.8971V12C15 13.1046 14.1046 14 13 14H2C0.89543 14 0 13.1046 0 12V2ZM8.90975 1.98276C9.23151 1.85778 9.59366 2.0173 9.71864 2.33905L10.3057 3.85037L10.3057 3.85044C10.5306 4.42953 10.2435 5.0814 9.66434 5.30637L8.15305 5.8934C7.83129 6.01838 7.46914 5.85886 7.34416 5.5371C7.21918 5.21535 7.3787 4.85319 7.70046 4.72822L8.20001 4.53418C8.09038 4.47969 7.97583 4.43188 7.8567 4.39144C6.4185 3.90327 4.85686 4.67342 4.36869 6.11162C4.26856 6.40662 4.22137 6.70682 4.22203 7.00187C4.22268 7.29422 4.08663 7.58262 3.82441 7.71197C3.45705 7.89312 3.01201 7.69337 2.98221 7.28482C2.94441 6.76677 3.00755 6.23267 3.18502 5.70984C3.89508 3.61792 6.16655 2.49771 8.25845 3.20777C8.4489 3.27242 8.6313 3.35 8.805 3.43922L8.55346 2.79165C8.42848 2.4699 8.58799 2.10774 8.90975 1.98276ZM6.30436 8.12463C6.64183 8.05206 6.97422 8.2668 7.04679 8.60427C7.11936 8.94173 6.90462 9.27413 6.56715 9.34669L5.84218 9.50259C5.92201 9.53848 6.00428 9.5709 6.08885 9.59962C7.52705 10.0878 9.0887 9.31762 9.57685 7.87942C9.677 7.58442 9.72415 7.28422 9.7235 6.98917C9.72285 6.69682 9.8589 6.40842 10.1211 6.27907C10.4885 6.09792 10.9335 6.29767 10.9633 6.70622C11.0011 7.22427 10.938 7.75837 10.7605 8.28122C10.0504 10.3731 7.779 11.4933 5.68709 10.7833C5.55894 10.7398 5.43444 10.6904 5.31378 10.6356L5.41882 11.1241C5.49138 11.4616 5.27663 11.794 4.93916 11.8665C4.6017 11.9391 4.26931 11.7244 4.19675 11.3869L3.85593 9.8018C3.72531 9.19434 4.11191 8.59608 4.7193 8.46548L6.30436 8.12463Z"
      fill="#B6B6B6"
    />
  </svg>
);

export const CloudNotSavedIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2962 4.53678C12.3403 3.91487 14.6187 4.3126 16.2912 5.65287C17.3926 6.53397 18.1334 7.74987 18.382 9.08777C19.7283 9.43147 20.8323 10.3675 21.4117 11.5917C21.5889 11.9661 21.429 12.4133 21.0546 12.5905C20.6802 12.7676 20.233 12.6078 20.0558 12.2334C19.6075 11.286 18.6976 10.5987 17.6196 10.4678C17.2649 10.4247 16.9899 10.1374 16.9623 9.78117C16.8749 8.65267 16.3043 7.58421 15.354 6.82404C14.0838 5.80602 12.3231 5.48807 10.7331 5.97175C9.39388 6.37978 8.32176 7.31368 7.81257 8.51164C7.71358 8.74455 7.50381 8.91182 7.25471 8.95649C5.38135 9.29241 3.95001 10.8735 3.95001 12.7982C3.95001 14.97 5.7743 16.7055 7.99272 16.7092H12.153C12.5672 16.7092 12.903 17.045 12.903 17.4592C12.903 17.8734 12.5672 18.2092 12.153 18.2092L7.99039 18.2092C5.00443 18.2046 2.45001 15.8567 2.45001 12.7982C2.45001 10.2307 4.25631 8.15895 6.60069 7.5642C7.34566 6.10673 8.69713 5.0239 10.2962 4.53678Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 20C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5C14 18.433 15.567 20 17.5 20ZM15 17H20V16H15V17Z"
      fill="#EA4335"
    />
  </svg>
);

export const CloudSavingIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2962 4.53678C12.3403 3.91487 14.6187 4.3126 16.2912 5.65287C17.3926 6.53397 18.1334 7.74987 18.382 9.08777C19.7283 9.43147 20.8323 10.3675 21.4117 11.5917C21.5889 11.9661 21.429 12.4133 21.0546 12.5905C20.6802 12.7676 20.233 12.6078 20.0558 12.2334C19.6075 11.286 18.6976 10.5987 17.6196 10.4678C17.2649 10.4247 16.9899 10.1374 16.9623 9.78117C16.8749 8.65267 16.3043 7.58421 15.354 6.82404C14.0838 5.80602 12.3231 5.48807 10.7331 5.97175C9.39388 6.37978 8.32176 7.31368 7.81257 8.51164C7.71358 8.74455 7.50381 8.91182 7.25471 8.95649C5.38135 9.29241 3.95001 10.8735 3.95001 12.7982C3.95001 14.97 5.7743 16.7055 7.99272 16.7092H12.153C12.5672 16.7092 12.903 17.045 12.903 17.4592C12.903 17.8734 12.5672 18.2092 12.153 18.2092L7.99039 18.2092C5.00443 18.2046 2.45001 15.8567 2.45001 12.7982C2.45001 10.2307 4.25631 8.15895 6.60069 7.5642C7.34566 6.10673 8.69713 5.0239 10.2962 4.53678Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 20C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5C14 18.433 15.567 20 17.5 20ZM18.036 18.4449C18.036 18.7515 17.796 19 17.5 19C17.204 19 16.964 18.7515 16.964 18.4449V15.8954L15.9149 16.9821C15.7056 17.1989 15.3663 17.1989 15.157 16.9821C14.9477 16.7653 14.9477 16.4138 15.157 16.197L17.121 14.1626C17.2215 14.0585 17.3579 14 17.5 14C17.6421 14 17.7785 14.0585 17.879 14.1626L19.843 16.197C20.0523 16.4138 20.0523 16.7653 19.843 16.9821C19.6337 17.1989 19.2944 17.1989 19.0851 16.9821L18.036 15.8954V18.4449Z"
      fill="#EAEA47"
    />
  </svg>
);

export const CloudSavedIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2962 4.53678C12.3403 3.91487 14.6187 4.3126 16.2912 5.65287C17.3926 6.53397 18.1334 7.74987 18.382 9.08777C19.7283 9.43147 20.8323 10.3675 21.4117 11.5917C21.5889 11.9661 21.429 12.4133 21.0546 12.5905C20.6802 12.7676 20.233 12.6078 20.0558 12.2334C19.6075 11.286 18.6976 10.5987 17.6196 10.4678C17.2649 10.4247 16.9899 10.1374 16.9623 9.78117C16.8749 8.65267 16.3043 7.58421 15.354 6.82404C14.0838 5.80602 12.3231 5.48807 10.7331 5.97175C9.39388 6.37978 8.32176 7.31368 7.81257 8.51164C7.71358 8.74455 7.50381 8.91182 7.25471 8.95649C5.38135 9.29241 3.95001 10.8735 3.95001 12.7982C3.95001 14.97 5.7743 16.7055 7.99272 16.7092H12.153C12.5672 16.7092 12.903 17.045 12.903 17.4592C12.903 17.8734 12.5672 18.2092 12.153 18.2092L7.99039 18.2092C5.00443 18.2046 2.45001 15.8567 2.45001 12.7982C2.45001 10.2307 4.25631 8.15895 6.60069 7.5642C7.34566 6.10673 8.69713 5.0239 10.2962 4.53678Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 20C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C15.567 13 14 14.567 14 16.5C14 18.433 15.567 20 17.5 20ZM16.875 17.1852L19.226 14.75L20 15.5321L16.875 18.75L15 16.9125L15.7737 16.1302L16.875 17.1852Z"
      fill="#0EAF00"
    />
  </svg>
);

export const SuperHeroIcon = () => (
  <svg
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0817 7.80898C13.8891 7.50067 14.6516 6.95012 15.0777 6.44361C15.9972 5.32049 16.1766 3.0302 16.199 2.76593C16.2214 2.28145 15.8626 1.86303 15.3692 1.841C14.8758 1.81898 14.4497 2.17134 14.4273 2.65582C14.3825 3.47064 14.1134 4.836 13.7097 5.34251C13.3284 5.80497 12.3641 6.31148 11.8932 6.31148C11.8932 6.31148 9.08987 6.24542 8.01341 6.24542C5.05315 6.24542 3.77485 9.50468 2.76567 12.1253C2.24987 13.4686 1.71164 14.834 1.12855 15.2084C0.993996 15.2965 0.926717 15.4066 0.904291 15.5607C0.881865 15.7149 0.949143 15.847 1.06127 15.9571C1.44252 16.3095 3.90941 16.7279 6.66784 17.0142L5.56895 20.7359C5.41197 21.2865 5.72594 21.8811 6.30902 22.0352C6.39872 22.0572 6.51085 22.0793 6.60056 22.0793C7.07151 22.0793 7.49761 21.771 7.63217 21.3085L8.84319 17.2124C9.1123 17.2344 9.38142 17.2564 9.65053 17.2785L9.56083 21.0002C9.5384 21.5728 10.0094 22.0573 10.6149 22.0793C11.1979 22.1013 11.6913 21.6388 11.7137 21.0442L11.8035 17.4326C12.5211 17.4767 13.1939 17.4987 13.7321 17.4987C14.3152 17.4987 14.7637 17.4767 15.0553 17.4326C15.1898 17.4106 15.3244 17.3225 15.3917 17.1904C15.4589 17.0582 15.4589 16.9041 15.3917 16.772C14.8983 15.781 13.7545 10.848 13.0817 7.80898ZM2.22744 15.4727C2.76567 14.768 3.19177 13.6889 3.64029 12.4997C4.49249 10.2975 5.45682 7.80898 7.29577 7.30247C7.27335 7.3245 7.25092 7.34652 7.25092 7.36854C6.95938 7.831 5.43439 11.0242 5.12043 11.6628C4.91859 12.1033 5.098 12.6098 5.54653 12.808C5.65866 12.8741 5.79321 12.8961 5.92777 12.8961C6.26417 12.8961 6.57813 12.7199 6.73512 12.3896C7.2285 11.3766 7.7443 10.2975 8.12554 9.50468L7.96856 12.5217L6.8921 16.1333C4.91859 15.9351 3.12449 15.6709 2.22744 15.4727ZM9.08987 16.3535L9.69538 14.3055L9.65053 16.3976C9.47112 16.3976 9.26928 16.3756 9.08987 16.3535ZM11.8035 16.5517L11.8932 12.83L12.2744 8.57975C12.7454 10.7379 13.6873 14.834 14.2703 16.5958C13.6648 16.6178 12.7902 16.5958 11.8035 16.5517Z"
      fill="white"
    />
    <path
      d="M10.35 5.51998C11.5926 5.51998 12.6 4.49024 12.6 3.21998C12.6 1.94973 11.5926 0.919983 10.35 0.919983C9.10737 0.919983 8.10001 1.94973 8.10001 3.21998C8.10001 4.49024 9.10737 5.51998 10.35 5.51998Z"
      fill="white"
    />
  </svg>
);

export const Open24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 8.44444C5 6.55883 6.55883 5 8.44444 5H13.7778C14.3301 5 14.7778 5.44772 14.7778 6C14.7778 6.55228 14.3301 7 13.7778 7H8.44444C7.6634 7 7 7.6634 7 8.44444V23.4444C7 24.2255 7.6634 24.8889 8.44444 24.8889H23.4444C24.2255 24.8889 24.8889 24.2255 24.8889 23.4444V18.1111C24.8889 17.5588 25.3366 17.1111 25.8889 17.1111C26.4412 17.1111 26.8889 17.5588 26.8889 18.1111V23.4444C26.8889 25.3301 25.3301 26.8889 23.4444 26.8889H8.44444C6.55883 26.8889 5 25.3301 5 23.4444V8.44444ZM17.2222 6C17.2222 5.44772 17.6699 5 18.2222 5H26C26.5523 5 27 5.44772 27 6V13.7778C27 14.3301 26.5523 14.7778 26 14.7778C25.4477 14.7778 25 14.3301 25 13.7778V8.41421L21.8182 11.596C21.4277 11.9865 20.7945 11.9865 20.404 11.596C20.0135 11.2055 20.0135 10.5723 20.404 10.1818L23.5858 7H18.2222C17.6699 7 17.2222 6.55228 17.2222 6Z"
      fill="white"
    />
  </svg>
);

export const ArrowsPointingInwardIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.38068 6.61094L2.46392 6.24069C2.46392 6.24069 1.94245 6.25449 2.23289 5.96405C2.52573 5.67241 3.23143 4.96551 3.23143 4.96551C3.23143 4.96551 3.05921 4.79388 2.79697 4.52925C2.04326 3.77554 0.672069 2.40435 0.11399 1.84627C0.11399 1.84627 -0.0792371 1.73345 0.152396 1.50422C0.383428 1.27079 1.39277 0.260843 1.55779 0.0976203C1.72042 -0.067403 1.84524 0.0658158 1.84524 0.0658158C2.38771 0.605892 3.80751 2.02449 4.53482 2.7536C4.77185 2.99003 4.92607 3.14485 4.92607 3.14485C4.92607 3.14485 5.49195 2.57777 5.8496 2.22132C6.20485 1.86607 6.20245 2.40195 6.20245 2.40195C6.20245 2.40195 6.69812 5.91124 6.69812 6.3307C6.69872 6.63675 6.38068 6.61094 6.38068 6.61094Z"
      fill="white"
    />
    <path
      d="M13.657 13.5482L17.5726 13.9185C17.5726 13.9185 18.0952 13.9034 17.8048 14.1939C17.5132 14.4855 16.8051 15.196 16.8051 15.196C16.8051 15.196 16.9761 15.3647 17.2413 15.6299C17.9962 16.3836 19.3662 17.7548 19.9255 18.3153C19.9255 18.3153 20.1163 18.4245 19.8871 18.6537C19.6561 18.886 18.6449 19.8983 18.4781 20.0627C18.3161 20.2253 18.1931 20.0957 18.1931 20.0957C17.6506 19.5521 16.2308 18.1346 15.5023 17.4061C15.2664 17.1703 15.1146 17.0173 15.1146 17.0173C15.1146 17.0173 14.5475 17.582 14.1887 17.9384C13.8334 18.2949 13.8334 17.759 13.8334 17.759C13.8334 17.759 13.3414 14.2473 13.3414 13.8302C13.3402 13.5236 13.657 13.5482 13.657 13.5482Z"
      fill="white"
    />
    <path
      d="M6.59752 13.8086L6.22847 17.7266C6.22847 17.7266 6.24347 18.2505 5.95183 17.9576C5.65899 17.6636 4.95089 16.9579 4.95089 16.9579C4.95089 16.9579 4.77866 17.1301 4.51823 17.3941C3.76332 18.149 2.38973 19.519 1.83165 20.0795C1.83165 20.0795 1.72003 20.2679 1.4896 20.0387C1.25917 19.8095 0.249824 18.7953 0.0829999 18.6345C-0.0820235 18.4707 0.0499952 18.3453 0.0499952 18.3453C0.592472 17.8052 2.00987 16.3842 2.73958 15.6557C2.97661 15.4199 3.13083 15.2656 3.13083 15.2656C3.13083 15.2656 2.56495 14.6985 2.2073 14.3445C1.84965 13.9868 2.38553 13.9892 2.38553 13.9892C2.38553 13.9892 5.89722 13.496 6.31788 13.496C6.62333 13.4942 6.59752 13.8086 6.59752 13.8086Z"
      fill="white"
    />
    <path
      d="M13.3437 6.34201L13.7128 2.42285C13.7128 2.42285 13.699 1.90258 13.9894 2.19302C14.2823 2.48586 14.9892 3.19396 14.9892 3.19396C14.9892 3.19396 15.1614 3.02174 15.4266 2.7577C16.1803 2.00279 17.5503 0.632798 18.1096 0.0747185C18.1096 0.0747185 18.2212 -0.117309 18.4517 0.114324C18.6827 0.342956 19.6926 1.3541 19.8571 1.51732C20.0233 1.68235 19.8913 1.80656 19.8913 1.80656C19.35 2.34904 17.9302 3.76764 17.2029 4.49614C16.9653 4.73078 16.8092 4.885 16.8092 4.885C16.8092 4.885 17.3775 5.45088 17.734 5.80733C18.0892 6.16618 17.5557 6.16258 17.5557 6.16258C17.5557 6.16258 14.044 6.65705 13.6234 6.65705C13.3191 6.65885 13.3437 6.34201 13.3437 6.34201Z"
      fill="white"
    />
    <circle cx="9.95919" cy="9.92031" r="1.98477" fill="white" />
  </svg>
);

export const TrashIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 6H21M5 6V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V6M8 6V4C8 2.89543 8.89543 2 10 2H14C15.1046 2 16 2.89543 16 4V6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 11V17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11V17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SunIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 19C12.2449 19 12.4813 19.09 12.6644 19.2527C12.8474 19.4155 12.9643 19.6397 12.993 19.883L13 20V21C12.9997 21.2549 12.9021 21.5 12.7271 21.6854C12.5522 21.8707 12.313 21.9822 12.0586 21.9972C11.8042 22.0121 11.5536 21.9293 11.3582 21.7657C11.1627 21.6021 11.0371 21.3701 11.007 21.117L11 21V20C11 19.7348 11.1053 19.4804 11.2929 19.2929C11.4804 19.1054 11.7348 19 12 19Z"
      fill="white"
    />
    <path
      d="M18.313 16.91L18.407 16.993L19.107 17.693C19.2863 17.873 19.3905 18.1144 19.3982 18.3684C19.406 18.6223 19.3168 18.8697 19.1487 19.0603C18.9807 19.2508 18.7464 19.3703 18.4935 19.3944C18.2406 19.4185 17.988 19.3454 17.787 19.19L17.693 19.107L16.993 18.407C16.8204 18.2347 16.7167 18.0054 16.7015 17.762C16.6862 17.5187 16.7603 17.2781 16.9099 17.0856C17.0596 16.8931 17.2744 16.7619 17.514 16.7166C17.7536 16.6714 18.0015 16.7153 18.211 16.84L18.313 16.91Z"
      fill="white"
    />
    <path
      d="M7.00699 16.993C7.17917 17.1652 7.2826 17.3943 7.29788 17.6373C7.31316 17.8803 7.23924 18.1206 7.08999 18.313L7.00699 18.407L6.30699 19.107C6.12703 19.2863 5.88556 19.3905 5.63161 19.3982C5.37766 19.406 5.13028 19.3168 4.93971 19.1488C4.74915 18.9807 4.62969 18.7464 4.60559 18.4935C4.5815 18.2406 4.65458 17.988 4.80999 17.787L4.89299 17.693L5.59299 16.993C5.78052 16.8055 6.03483 16.7002 6.29999 16.7002C6.56516 16.7002 6.81946 16.8055 7.00699 16.993Z"
      fill="white"
    />
    <path
      d="M3.99999 11C4.25487 11.0003 4.50002 11.0979 4.68536 11.2728C4.8707 11.4478 4.98223 11.687 4.99716 11.9414C5.0121 12.1958 4.92932 12.4464 4.76573 12.6418C4.60214 12.8373 4.37009 12.9629 4.11699 12.993L3.99999 13H2.99999C2.74511 12.9997 2.49996 12.9021 2.31462 12.7272C2.12929 12.5522 2.01776 12.313 2.00282 12.0586C1.98788 11.8042 2.07067 11.5536 2.23426 11.3582C2.39785 11.1627 2.62989 11.0371 2.88299 11.007L2.99999 11H3.99999Z"
      fill="white"
    />
    <path
      d="M21 11C21.2549 11.0003 21.5 11.0979 21.6854 11.2728C21.8707 11.4478 21.9822 11.687 21.9972 11.9414C22.0121 12.1958 21.9293 12.4464 21.7657 12.6418C21.6021 12.8373 21.3701 12.9629 21.117 12.993L21 13H20C19.7451 12.9997 19.5 12.9021 19.3146 12.7272C19.1293 12.5522 19.0178 12.313 19.0028 12.0586C18.9879 11.8042 19.0707 11.5536 19.2343 11.3582C19.3978 11.1627 19.6299 11.0371 19.883 11.007L20 11H21Z"
      fill="white"
    />
    <path
      d="M6.21299 4.81L6.30699 4.893L7.00699 5.593C7.18634 5.77296 7.29046 6.01443 7.29822 6.26838C7.30597 6.52233 7.21678 6.76971 7.04874 6.96028C6.88071 7.15084 6.64644 7.27031 6.39352 7.2944C6.14059 7.31849 5.88798 7.24541 5.68699 7.09L5.59299 7.007L4.89299 6.307C4.72108 6.13468 4.61792 5.90557 4.60286 5.66263C4.58779 5.41969 4.66185 5.17959 4.81115 4.98735C4.96046 4.79511 5.17475 4.66393 5.41386 4.61839C5.65297 4.57285 5.90048 4.61609 6.10999 4.74L6.21299 4.81Z"
      fill="white"
    />
    <path
      d="M19.107 4.893C19.2792 5.06519 19.3826 5.29429 19.3979 5.53732C19.4132 5.78034 19.3392 6.0206 19.19 6.213L19.107 6.307L18.407 7.007C18.227 7.18635 17.9856 7.29047 17.7316 7.29823C17.4777 7.30598 17.2303 7.21678 17.0397 7.04875C16.8491 6.88072 16.7297 6.64645 16.7056 6.39353C16.6815 6.1406 16.7546 5.88799 16.91 5.687L16.993 5.593L17.693 4.893C17.8805 4.70553 18.1348 4.60021 18.4 4.60021C18.6652 4.60021 18.9195 4.70553 19.107 4.893Z"
      fill="white"
    />
    <path
      d="M12 2C12.2449 2.00003 12.4813 2.08996 12.6644 2.25272C12.8474 2.41547 12.9643 2.63975 12.993 2.883L13 3V4C12.9997 4.25488 12.9021 4.50003 12.7271 4.68537C12.5522 4.8707 12.313 4.98223 12.0586 4.99717C11.8042 5.01211 11.5536 4.92933 11.3582 4.76574C11.1627 4.60214 11.0371 4.3701 11.007 4.117L11 4V3C11 2.73478 11.1053 2.48043 11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2Z"
      fill="white"
    />
    <path
      d="M12 7C12.9797 6.99994 13.9378 7.28769 14.7553 7.8275C15.5729 8.36731 16.2138 9.1354 16.5986 10.0364C16.9833 10.9373 17.0949 11.9315 16.9195 12.8953C16.744 13.8592 16.2893 14.7502 15.6118 15.4579C14.9343 16.1655 14.0638 16.6585 13.1085 16.8756C12.1532 17.0928 11.1552 17.0245 10.2383 16.6793C9.32149 16.334 8.52628 15.7271 7.95145 14.9338C7.37662 14.1405 7.04751 13.1958 7.00499 12.217L6.99999 12L7.00499 11.783C7.06091 10.4958 7.6116 9.27978 8.54221 8.38866C9.47283 7.49754 10.7115 7.00007 12 7Z"
      fill="white"
    />
  </svg>
);

// Illustration-grade art: served from ui_assets (cached, on-demand)
// instead of inlining tens of KiB of path data into the JS bundle.
export const GeospatialIcon = () => (
  <img src="/ui_assets/icons/geospatial.svg" width="20" height="24" alt="" />
);

// (GeospatialIconWhite was removed — no consumers; the art lives on in git history.)

export const Camera32Icon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.44444 9.5625H8.66667C9.31497 9.5625 9.93673 9.31228 10.3952 8.86688C10.8536 8.42148 11.1111 7.81739 11.1111 7.1875C11.1111 6.87256 11.2399 6.57051 11.4691 6.34781C11.6983 6.12511 12.0092 6 12.3333 6H19.6667C19.9908 6 20.3017 6.12511 20.5309 6.34781C20.7601 6.57051 20.8889 6.87256 20.8889 7.1875C20.8889 7.81739 21.1464 8.42148 21.6049 8.86688C22.0633 9.31228 22.685 9.5625 23.3333 9.5625H24.5556C25.2039 9.5625 25.8256 9.81272 26.284 10.2581C26.7425 10.7035 27 11.3076 27 11.9375V22.625C27 23.2549 26.7425 23.859 26.284 24.3044C25.8256 24.7498 25.2039 25 24.5556 25H7.44444C6.79614 25 6.17438 24.7498 5.71596 24.3044C5.25754 23.859 5 23.2549 5 22.625V11.9375C5 11.3076 5.25754 10.7035 5.71596 10.2581C6.17438 9.81272 6.79614 9.5625 7.44444 9.5625Z"
      stroke="white"
      strokeWidth="1.5"
    />
    <path
      d="M16 20.25C18.025 20.25 19.6667 18.655 19.6667 16.6875C19.6667 14.72 18.025 13.125 16 13.125C13.975 13.125 12.3333 14.72 12.3333 16.6875C12.3333 18.655 13.975 20.25 16 20.25Z"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export const VideoCameraIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3333 13.5915L19.1667 16.1469V8.22815L15.3333 10.7835V13.5915ZM15.3333 8.48019L19.5931 5.64017C20.2304 5.21562 21.0833 5.67227 21.0833 6.4375V17.9375C21.0833 18.7027 20.2304 19.1594 19.5931 18.7348L15.3333 15.8948V16.9753C15.3333 18.2988 14.259 19.375 12.9394 19.375H2.39392C2.07913 19.3747 1.76748 19.3125 1.47678 19.1917C1.18607 19.071 0.922013 18.8941 0.699692 18.6712C0.477372 18.4484 0.301147 18.1839 0.181091 17.8929C0.0610341 17.6019 -0.000500689 17.2901 3.06815e-06 16.9753V7.39967C3.06815e-06 6.07621 1.07429 5 2.39392 5H12.9394C13.2542 5.00025 13.5659 5.06253 13.8566 5.18329C14.1473 5.30404 14.4113 5.4809 14.6336 5.70376C14.856 5.92661 15.0322 6.19109 15.1523 6.48209C15.2723 6.77308 15.3338 7.08488 15.3333 7.39967V8.48019ZM1.91667 7.39967V16.9753C1.91616 17.0384 1.92812 17.101 1.95186 17.1594C1.97559 17.2179 2.01063 17.2711 2.05498 17.316C2.09932 17.3608 2.15209 17.3965 2.21025 17.4209C2.26842 17.4454 2.33083 17.4581 2.39392 17.4583H12.9394C13.1996 17.4583 13.4167 17.2408 13.4167 16.9753V7.39967C13.4172 7.33658 13.4052 7.27402 13.3815 7.21556C13.3578 7.15711 13.3227 7.10392 13.2784 7.05904C13.234 7.01417 13.1813 6.97849 13.1231 6.95406C13.0649 6.92962 13.0025 6.91692 12.9394 6.91667H2.39392C2.13373 6.91667 1.91667 7.13421 1.91667 7.39967Z"
      fill="white"
    />
  </svg>
);

export const Rotate24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.3333 10L15.3333 4.66667L12 4.66667L16.6666 -2.03987e-07L21.3333 4.66667L18 4.66667L18 10C18 11.0506 17.7931 12.0909 17.391 13.0615C16.989 14.0321 16.3997 14.914 15.6568 15.6569C14.914 16.3997 14.0321 16.989 13.0614 17.391C12.0908 17.7931 11.0506 18 9.99998 18L4.66664 18L4.66665 21.3333L-2.42525e-05 16.6667L4.66664 12L4.66664 15.3333L9.99998 15.3333C10.7004 15.3333 11.3939 15.1954 12.041 14.9274C12.688 14.6593 13.276 14.2665 13.7712 13.7712C14.2665 13.276 14.6593 12.6881 14.9273 12.041C15.1954 11.3939 15.3333 10.7004 15.3333 10Z"
      fill="white"
    />
  </svg>
);

export const Translate24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8665 11.4315L18.4161 6.54248V9.72583H11.4385H4.47479V6.54248L0 11.4315L4.47653 16.3188L4.47479 13.172H11.4385H18.4161L18.4144 16.3188L22.8665 11.4315Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1559 11.4367H13.1785V4.47305L16.3236 4.47479L11.438 0L6.54899 4.47305H9.69753V11.4367H9.71146V18.4022L6.52985 18.4004L11.4154 22.8857L16.2975 18.4022H13.1559V11.4367Z"
      fill="white"
    />
  </svg>
);

// The easy move gizmo's own glyph, drawn as the gizmo looks: a square with a
// marker on each side, inside a ring whose two arrowheads point up into the
// gap at the top. Pixel-aligned, with a 1px gap between the square and its
// markers and bold arrowheads, so it stays legible at 24px on a 1x display
// (#2064): markers touching the square blur into a bumpy dot there, and small
// arrowheads vanish into the ring.
export const EasyTransform24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 10H14V14H10Z" fill="white" />
    <path d="M10 9H14L12 6Z" fill="white" />
    <path d="M10 15H14L12 18Z" fill="white" />
    <path d="M9 10V14L6 12Z" fill="white" />
    <path d="M15 10V14L18 12Z" fill="white" />
    <path
      d="M20.87 8.6A9.5 9.5 0 1 1 3.13 8.6"
      stroke="white"
      strokeWidth="2"
      fill="none"
    />
    <path d="M18.11 4.72L18.35 9.71L23.52 7.84Z" fill="white" />
    <path d="M5.89 4.72L5.65 9.71L0.48 7.84Z" fill="white" />
  </svg>
);

export const Cloud24Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M10.2964 5.03672C12.3404 4.41481 14.6189 4.81254 16.2914 6.1528C17.3928 7.03391 18.1336 8.24981 18.3822 9.58771C19.7285 9.93141 20.8325 10.8675 21.4119 12.0917C21.589 12.4661 21.4292 12.9132 21.0548 13.0904C20.6804 13.2676 20.2332 13.1077 20.056 12.7333C19.6077 11.7859 18.6978 11.0987 17.6198 10.9678C17.2651 10.9247 16.9901 10.6374 16.9625 10.2811C16.8751 9.15261 16.3045 8.08415 15.3542 7.32398C14.084 6.30596 12.3233 5.98801 10.7333 6.47169C9.39406 6.87972 8.32194 7.81362 7.81276 9.01158C7.71376 9.24448 7.50399 9.41176 7.25489 9.45643C5.38153 9.79234 3.9502 11.3735 3.9502 13.2982C3.9502 15.47 5.77448 17.2054 7.9929 17.2092H12.1532C12.5674 17.2092 12.9032 17.545 12.9032 17.9592C12.9032 18.3734 12.5674 18.7092 12.1532 18.7092L7.99057 18.7092C5.00462 18.7045 2.4502 16.3567 2.4502 13.2982C2.4502 10.7306 4.25649 8.65889 6.60087 8.06414C7.34584 6.60667 8.69731 5.52384 10.2964 5.03672Z"
      fill="#3D3D3D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6029 13.8973C18.0171 13.8973 18.3529 14.2331 18.3529 14.6473V18.0917L19.821 16.6236C20.1139 16.3307 20.5887 16.3307 20.8816 16.6236C21.1745 16.9165 21.1745 17.3914 20.8816 17.6842L18.1332 20.4327C17.9925 20.5733 17.8018 20.6524 17.6029 20.6524C17.4039 20.6524 17.2132 20.5733 17.0725 20.4327L14.3241 17.6842C14.0312 17.3914 14.0312 16.9165 14.3241 16.6236C14.617 16.3307 15.0919 16.3307 15.3848 16.6236L16.8529 18.0917V14.6473C16.8529 14.2331 17.1886 13.8973 17.6029 13.8973Z"
      fill="#3D3D3D"
    />
  </svg>
);

export const Load24Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M7.79149 17.5C7.57184 17.5 7.34525 17.4871 7.10998 17.4623L7.04748 17.454C4.27631 17.0542 2.20054 14.6439 2 11.5921L5.72353 11.3163C5.78778 12.2916 6.36858 13.3497 7.52149 13.5326C8.67007 13.6456 9.20051 13.0518 10.4046 11.3558C11.3952 9.9586 12.628 8.22125 14.8045 7.66143C15.7088 7.43693 16.651 7.44672 17.551 7.68996C18.451 7.9332 19.2823 8.40271 19.9744 9.05867C20.6936 9.72652 21.2501 10.5683 21.5965 11.5124C21.9429 12.4566 22.069 13.4753 21.9642 14.4822L18.2554 14.0336C18.2923 13.659 18.2432 13.2805 18.1123 12.9304C17.9814 12.5802 17.7726 12.2687 17.5036 12.0223C16.9827 11.5332 16.3177 11.3457 15.6848 11.5084C14.8514 11.7226 14.2697 12.4938 13.3894 13.7348C12.2486 15.3389 10.7137 17.4991 7.79149 17.5Z"
      fill="white"
    />
  </svg>
);

export const Save24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 15.9375V17.8125C4.5 18.3098 4.69754 18.7867 5.04917 19.1383C5.40081 19.49 5.87772 19.6875 6.375 19.6875H17.625C18.1223 19.6875 18.5992 19.49 18.9508 19.1383C19.3025 18.7867 19.5 18.3098 19.5 17.8125V15.9375M7.3125 10.3125L12 15M12 15L16.6875 10.3125M12 15V3.75"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Upload24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 15.9375V17.8125C4.5 18.3098 4.69754 18.7867 5.04917 19.1383C5.40081 19.49 5.87772 19.6875 6.375 19.6875H17.625C18.1223 19.6875 18.5992 19.49 18.9508 19.1383C19.3025 18.7867 19.5 18.3098 19.5 17.8125V15.9375M7.3125 8.4375L12 3.75M12 3.75L16.6875 8.4375M12 3.75V15"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cross32Icon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6667 10.6667L21.3333 21.3333M21.3333 10.6667L10.6667 21.3333"
      stroke="#DBDBDB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cross24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8L16 16M16 8L8 16"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Compass32Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M25.5 8.5L12 12.5L21 20.5L25.5 8.5Z" fill="#DBDBDB" />
    <path
      d="M12 12.5L7.5 24.5L21 20.5M12 12.5L25.5 8.5L21 20.5M12 12.5L21 20.5"
      stroke="#DBDBDB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowDown24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 9L12 14L7 9"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowUp24Icon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 14L12 9L17 14"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckIcon = (className) => (
  <svg
    className={className}
    width="8"
    height="7"
    viewBox="0 0 8 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 3.5L3.08333 5.33333L7.08333 1.33333"
      stroke="#DBDBDB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DropdownArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M14.1665 8.5L9.99984 12.6667L5.83317 8.5H14.1665Z" fill="white" />
  </svg>
);

export const Magnifier20Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.3335 2.41675C5.15786 2.41675 2.5835 4.99111 2.5835 8.16675C2.5835 11.3424 5.15786 13.9167 8.3335 13.9167C9.60821 13.9167 10.786 13.502 11.7394 12.8L16.1365 17.1971C16.4294 17.49 16.9043 17.49 17.1972 17.1971C17.4901 16.9042 17.4901 16.4293 17.1972 16.1364L12.8219 11.7611C13.6113 10.7766 14.0835 9.52683 14.0835 8.16675C14.0835 4.99111 11.5091 2.41675 8.3335 2.41675ZM8.3335 3.91675C5.98629 3.91675 4.0835 5.81954 4.0835 8.16675C4.0835 10.514 5.98629 12.4167 8.3335 12.4167C10.6807 12.4167 12.5835 10.514 12.5835 8.16675C12.5835 5.81954 10.6807 3.91675 8.3335 3.91675Z"
      fill="white"
    />
  </svg>
);

export const ZoomIn24Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5C11.4505 16.5 12.7903 16.0247 13.8725 15.2222L19.0962 20.4459C19.4303 20.78 19.9719 20.78 20.306 20.4459C20.6401 20.1118 20.6401 19.5702 20.306 19.2361L15.1073 14.0374C15.9919 12.9197 16.5 11.5163 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10ZM10.75 7.5C10.75 7.08579 10.4142 6.75 10 6.75C9.58579 6.75 9.25 7.08579 9.25 7.5V9.25H7.5C7.08579 9.25 6.75 9.58579 6.75 10C6.75 10.4142 7.08579 10.75 7.5 10.75H9.25V12.5C9.25 12.9142 9.58579 13.25 10 13.25C10.4142 13.25 10.75 12.9142 10.75 12.5V10.75H12.5C12.9142 10.75 13.25 10.4142 13.25 10C13.25 9.58579 12.9142 9.25 12.5 9.25H10.75V7.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ZoomOut24Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5C11.4505 16.5 12.7903 16.0247 13.8725 15.2222L19.0962 20.4459C19.4303 20.78 19.9719 20.78 20.306 20.4459C20.6401 20.1118 20.6401 19.5702 20.306 19.2361L15.1073 14.0374C15.9919 12.9197 16.5 11.5163 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5ZM5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15C7.23858 15 5 12.7614 5 10ZM7.5 9.25C7.08579 9.25 6.75 9.58579 6.75 10C6.75 10.4142 7.08579 10.75 7.5 10.75H12.5C12.9142 10.75 13.25 10.4142 13.25 10C13.25 9.58579 12.9142 9.25 12.5 9.25H7.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CameraReset24Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7C3 5.89543 3.89543 5 5 5H15C16.1046 5 17 5.89543 17 7V8.10289L20.4553 6.20909C21.1206 5.77698 22 6.25443 22 7.04771V16.9523C22 17.7456 21.1206 18.223 20.4553 17.7909L17 15.8971V17C17 18.1046 16.1046 19 15 19H5C3.89543 19 3 18.1046 3 17V7ZM11.1748 6.92C11.4531 6.81194 11.7665 6.95 11.8745 7.22822L12.3823 8.5354C12.5768 9.03608 12.3285 9.59986 11.8278 9.79439L10.5207 10.302C10.2424 10.41 9.929 10.272 9.82095 9.99378C9.7129 9.71556 9.85095 9.40213 10.1292 9.29408L10.5614 9.12622C10.4666 9.07908 10.3675 9.03774 10.2644 9.00276C9.02067 8.58052 7.67013 9.24663 7.24789 10.4904C7.16128 10.7455 7.12046 11.0052 7.12103 11.2603C7.12159 11.5132 7.00393 11.7626 6.77712 11.8745C6.45935 12.031 6.07442 11.8583 6.04864 11.5048C6.016 11.0567 6.07062 10.5948 6.22412 10.142C6.83829 8.33269 8.80254 7.36379 10.6118 7.97796C10.7766 8.03386 10.9344 8.10099 11.0847 8.17815L10.8672 7.61804C10.7591 7.33982 10.8972 7.02651 11.1754 6.91846L11.1748 6.92ZM8.92134 12.2288C9.21324 12.1663 9.50079 12.3522 9.56362 12.6441C9.62645 12.936 9.44062 13.2235 9.14862 13.286L8.52152 13.4207C8.59055 13.4516 8.6617 13.4796 8.73479 13.5045C9.97853 13.9268 11.3291 13.2606 11.7513 12.0169C11.8379 11.7618 11.8787 11.5021 11.8782 11.247C11.8776 10.9941 11.9953 10.7447 12.2221 10.6328C12.5399 10.4762 12.9248 10.649 12.9506 11.0025C12.9832 11.4506 12.9287 11.9125 12.7752 12.3653C12.161 14.1746 10.1968 15.1435 8.38748 14.5294C8.27664 14.4917 8.16901 14.4491 8.06466 14.4017L8.15549 14.8241C8.21823 15.116 8.03231 15.4035 7.74041 15.4662C7.44851 15.529 7.16094 15.3433 7.09811 15.0513L6.80333 13.6805C6.69039 13.1551 7.02468 12.6377 7.54986 12.5247L8.92134 12.2288Z"
      fill="currentColor"
    />
  </svg>
);

export const Edit32Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1264 7.12622C20.0212 6.23144 21.2348 5.72876 22.5002 5.72876C23.7656 5.72876 24.9792 6.23144 25.8739 7.12622C26.7687 8.021 27.2714 9.23459 27.2714 10.5C27.2714 11.7654 26.7687 12.979 25.8739 13.8738L11.8739 27.8738C11.6864 28.0613 11.432 28.1667 11.1668 28.1667H5.8335C5.28121 28.1667 4.8335 27.7189 4.8335 27.1667V21.8333C4.8335 21.5681 4.93885 21.3138 5.12639 21.1262L19.1264 7.12622ZM18.5002 10.5809L6.8335 22.2475V26.1667H10.7526L22.4193 14.5L18.5002 10.5809ZM23.8335 13.0858L19.9144 9.16666L20.5406 8.54044C21.0603 8.02073 21.7652 7.72876 22.5002 7.72876C23.2351 7.72876 23.94 8.02073 24.4597 8.54044C24.9794 9.06014 25.2714 9.76502 25.2714 10.5C25.2714 11.235 24.9794 11.9398 24.4597 12.4596L23.8335 13.0858Z"
      fill="white"
    />
  </svg>
);

export const Edit24Icon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9697 1.96967C11.6408 1.29858 12.5509 0.92157 13.5 0.92157C14.4491 0.92157 15.3592 1.29858 16.0303 1.96967C16.7014 2.64075 17.0784 3.55094 17.0784 4.5C17.0784 5.44905 16.7014 6.35924 16.0303 7.03033L5.53033 17.5303C5.38968 17.671 5.19891 17.75 5 17.75H1C0.585786 17.75 0.25 17.4142 0.25 17V13C0.25 12.8011 0.329018 12.6103 0.46967 12.4697L10.9697 1.96967ZM10.5 4.56066L1.75 13.3107V16.25H4.68934L13.4393 7.5L10.5 4.56066ZM14.5 6.43934L11.5607 3.5L12.0303 3.03033C12.4201 2.64055 12.9488 2.42157 13.5 2.42157C14.0512 2.42157 14.5799 2.64055 14.9697 3.03033C15.3595 3.42011 15.5784 3.94876 15.5784 4.5C15.5784 5.05123 15.3595 5.57989 14.9697 5.96967L14.5 6.43934Z"
      fill="white"
    />
  </svg>
);

export const CheckMark32Icon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8334 21.1997L26.3257 8.70752L27.7399 10.1217L13.8334 24.0282L5.58398 15.7787L6.9982 14.3645L13.8334 21.1997Z"
      fill="white"
    />
  </svg>
);

export const Action24 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3378 14.904C13.6326 14.7774 14.0066 14.8436 14.288 14.9766C14.5793 15.1143 14.7264 15.4207 14.8508 15.7179C14.8785 15.784 14.9529 15.817 15.0205 15.7933L16.0538 15.4303C16.8285 15.158 17.6982 14.8524 18.3896 15.2927C18.9383 15.642 19.0202 16.5189 18.5854 17.0027C18.4271 17.1788 18.2296 17.321 18.0035 17.4152L14.9001 18.7081C14.0247 19.0728 13.0202 18.6507 12.668 17.7702L12.667 17.7677L12.1222 16.5578C11.9047 16.0116 12.1553 15.3924 12.688 15.1499L13.3196 14.9118L13.3378 14.904Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.14766 6.03596C8.74706 5.39201 8.17539 4.55615 8.0772 3.8899C8.0191 3.49602 7.84485 3.09392 7.49667 2.80678C7.43208 2.75351 7.36907 2.70646 7.30633 2.66543C6.75116 2.30234 5.91188 2.48067 5.58104 3.05564C5.34829 3.46013 5.39926 3.8899 5.39926 3.8899C5.61143 5.33128 6.47425 6.94112 7.25784 8.00897C7.69437 8.60386 8.0632 9.05868 8.50143 8.49996L8.52747 8.46676L9.11276 7.26426C9.37573 6.89449 9.37981 6.40913 9.14766 6.03596Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1014 3.5999C14.1014 4.81493 13.1164 5.7999 11.9014 5.7999C10.6864 5.7999 9.7014 4.81493 9.7014 3.5999C9.7014 2.38488 10.6864 1.3999 11.9014 1.3999C13.1164 1.3999 14.1014 2.38488 14.1014 3.5999Z"
      fill="white"
    />
    <path
      d="M16.6517 8.4195L15.8598 8.82682C15.8003 8.85263 15.6866 8.89705 15.5411 8.90685C15.1511 8.93313 14.7723 8.74996 14.552 8.4195L14.5387 8.3995L14.2742 7.90559C14.19 7.76005 14.1064 7.61177 14.0508 7.48183C14.0225 7.41575 13.9873 7.32297 13.9689 7.21615C13.9443 7.07436 14.0695 6.96267 14.1957 6.89359L15.2229 6.33145C15.3249 6.27561 15.3883 6.16856 15.3883 6.05224V4.66296C15.3883 4.20483 15.5071 3.74953 15.7774 3.39029C15.8532 3.28962 15.9595 3.1977 16.0745 3.11712C16.4598 2.84712 16.9704 2.9877 17.2893 3.33356C17.3871 3.43954 17.4563 3.56861 17.4905 3.70866L17.5885 4.10975C17.6869 4.51258 17.7368 4.92574 17.7374 5.34042L17.7378 5.54692V5.54858C17.7381 5.66988 17.7347 5.79071 17.7287 5.9084C17.6875 6.72186 17.6538 7.68926 17.0079 8.18554C16.8746 8.28804 16.7455 8.36685 16.6517 8.4195Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5275 17.993C10.5304 18.042 10.5436 18.09 10.5664 18.1336L11.5912 20.1045C11.7646 20.438 11.8189 20.8207 11.7452 21.1893L11.7364 21.2332C11.624 21.7952 11.3551 22.1299 10.9808 22.3128C10.3824 22.6052 9.53639 22.4944 9.26855 21.8846L8.0014 18.9999C7.89641 18.7609 7.84963 18.5003 7.86491 18.2397L7.86603 18.2207L8.14083 15.8894C8.19869 15.1658 8.96002 14.7153 9.62438 15.0194L10.0695 15.2146C10.443 15.3856 10.6826 15.7586 10.6826 16.1694L10.5275 17.993Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0252 12.682L14.0263 12.6992C14.064 13.2642 13.7803 13.8023 13.2927 14.0904L12.1876 14.6234C11.9657 14.7304 11.7226 14.7859 11.4763 14.7859C11.2174 14.7859 10.9622 14.7245 10.7316 14.6068L9.77255 14.1171C9.26596 13.8355 8.96698 13.2872 9.00458 12.7088L9.0052 12.6992L9.00524 9.81013C9.01878 9.62236 9.06757 9.43876 9.14907 9.26895L9.99302 7.51082C10.2426 6.99075 10.7684 6.65992 11.3452 6.65992H11.6868C12.2637 6.65992 12.7894 6.99075 13.0391 7.51082L13.8833 9.26973C13.9633 9.43626 14.0117 9.61607 14.0263 9.80013L14.0252 12.682Z"
      fill="white"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.5C12.4142 3.5 12.75 3.83579 12.75 4.25V13.6893L16.1572 10.2822C16.4501 9.98928 16.9249 9.98928 17.2178 10.2822C17.5107 10.5751 17.5107 11.0499 17.2178 11.3428L12.5303 16.0303C12.2374 16.3232 11.7626 16.3232 11.4697 16.0303L6.78217 11.3428C6.48928 11.0499 6.48928 10.5751 6.78217 10.2822C7.07506 9.98928 7.54994 9.98928 7.84283 10.2822L11.25 13.6893V4.25C11.25 3.83579 11.5858 3.5 12 3.5ZM4.5 15.6875C4.91421 15.6875 5.25 16.0233 5.25 16.4375V18.3125C5.25 18.6109 5.36853 18.897 5.5795 19.108C5.79048 19.319 6.07663 19.4375 6.375 19.4375H17.625C17.9234 19.4375 18.2095 19.319 18.4205 19.108C18.6315 18.897 18.75 18.6109 18.75 18.3125V16.4375C18.75 16.0233 19.0858 15.6875 19.5 15.6875C19.9142 15.6875 20.25 16.0233 20.25 16.4375V18.3125C20.25 19.0087 19.9734 19.6764 19.4812 20.1687C18.9889 20.6609 18.3212 20.9375 17.625 20.9375H6.375C5.67881 20.9375 5.01113 20.6609 4.51884 20.1687C4.02656 19.6764 3.75 19.0087 3.75 18.3125V16.4375C3.75 16.0233 4.08579 15.6875 4.5 15.6875Z"
      fill="currentColor"
    />
  </svg>
);

export const Copy32Icon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.4414 11.8157C25.7636 11.1379 24.8443 10.7571 23.8857 10.7571H22.2429V9.11429C22.2429 8.15572 21.8621 7.23641 21.1843 6.5586C20.5064 5.88079 19.5871 5.5 18.6286 5.5H8.11429C7.15572 5.5 6.23641 5.88079 5.5586 6.5586C4.88079 7.23641 4.5 8.15572 4.5 9.11429V19.6286C4.5 20.5871 4.88079 21.5064 5.5586 22.1843C6.23641 22.8621 7.15572 23.2429 8.11429 23.2429H9.75714V24.8857C9.75714 25.8443 10.1379 26.7636 10.8157 27.4414C11.4936 28.1192 12.4129 28.5 13.3714 28.5H23.8857C24.8443 28.5 25.7636 28.1192 26.4414 27.4414C27.1192 26.7636 27.5 25.8443 27.5 24.8857V14.3714C27.5 13.4129 27.1192 12.4936 26.4414 11.8157ZM13.3714 12.7286C12.9357 12.7286 12.5178 12.9017 12.2098 13.2098C11.9017 13.5178 11.7286 13.9357 11.7286 14.3714V24.8857C11.7286 25.3214 11.9017 25.7393 12.2098 26.0474C12.5178 26.3555 12.9357 26.5286 13.3714 26.5286H23.8857C24.3214 26.5286 24.7393 26.3555 25.0474 26.0474C25.3555 25.7393 25.5286 25.3214 25.5286 24.8857V14.3714C25.5286 13.9357 25.3555 13.5178 25.0474 13.2098C24.7393 12.9017 24.3214 12.7286 23.8857 12.7286H13.3714ZM10.8157 11.8157C11.4936 11.1379 12.4129 10.7571 13.3714 10.7571H20.2714V9.11429C20.2714 8.67857 20.0983 8.26071 19.7902 7.95261C19.4822 7.64451 19.0643 7.47143 18.6286 7.47143H8.11429C7.67857 7.47143 7.26071 7.64452 6.95261 7.95261C6.64452 8.26071 6.47143 8.67857 6.47143 9.11429V19.6286C6.47143 20.0643 6.64451 20.4822 6.95261 20.7902C7.26071 21.0983 7.67857 21.2714 8.11429 21.2714H9.75714V14.3714C9.75714 13.4129 10.1379 12.4936 10.8157 11.8157Z"
      fill="#DBDBDB"
    />
  </svg>
);

export const DropdownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M11.5 5C11.5 5.82843 10.8284 6.5 10 6.5C9.17157 6.5 8.5 5.82843 8.5 5C8.5 4.17157 9.17157 3.5 10 3.5C10.8284 3.5 11.5 4.17157 11.5 5Z"
      fill="#DBDBDB"
    />
    <path
      d="M11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5C10.8284 8.5 11.5 9.17157 11.5 10Z"
      fill="#DBDBDB"
    />
    <path
      d="M11.5 15C11.5 15.8284 10.8284 16.5 10 16.5C9.17157 16.5 8.5 15.8284 8.5 15C8.5 14.1716 9.17157 13.5 10 13.5C10.8284 13.5 11.5 14.1716 11.5 15Z"
      fill="#DBDBDB"
    />
  </svg>
);

export const Loader = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_5660_23745)">
      <path
        d="M36.728 11.7722L33.9 14.6002C31.6098 12.3098 28.5963 10.8843 25.373 10.5667C22.1496 10.249 18.9159 11.0588 16.2227 12.8582C13.5295 14.6575 11.5435 17.335 10.6031 20.4344C9.66268 23.5338 9.82605 26.8635 11.0654 29.8559C12.3047 32.8484 14.5432 35.3186 17.3997 36.8456C20.2561 38.3727 23.5536 38.862 26.7304 38.2304C29.9071 37.5987 32.7666 35.885 34.8215 33.3814C36.8765 30.8778 37.9998 27.7391 38 24.5002H42C42 28.6646 40.556 32.7001 37.9141 35.9192C35.2722 39.1383 31.5959 41.3418 27.5115 42.1542C23.4271 42.9666 19.1874 42.3377 15.5147 40.3745C11.8421 38.4114 8.96374 35.2356 7.37012 31.3882C5.77651 27.5408 5.56623 23.2598 6.77512 19.2748C7.984 15.2897 10.5373 11.8471 13.9998 9.53351C17.4624 7.21992 21.6201 6.17851 25.7644 6.58671C29.9088 6.99492 33.7834 8.8275 36.728 11.7722Z"
        fill="#B6B6B6"
      />
    </g>
    <defs>
      <clipPath id="clip0_5660_23745">
        <rect
          width="48"
          height="48"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const RemixIcon = ({ className }) => (
  <svg
    viewBox="0 0 95 65"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className={className}
  >
    <path
      d="M 78.452 29.527 C 78.852 29.927 79.352 30.127 79.852 30.127 C 80.352 30.127 80.852 29.927 81.252 29.527 L 90.252 20.527 C 90.352 20.427 90.452 20.327 90.452 20.227 C 90.452 20.227 90.452 20.127 90.452 20.127 C 90.552 20.027 90.552 19.927 90.552 19.827 C 90.552 19.827 90.552 19.727 90.552 19.727 C 90.552 19.627 90.652 19.527 90.652 19.427 C 90.652 19.327 90.652 19.127 90.652 19.027 C 90.652 18.927 90.652 18.727 90.652 18.627 C 90.652 18.527 90.652 18.427 90.552 18.327 C 90.552 18.327 90.552 18.227 90.552 18.227 C 90.552 18.127 90.452 18.027 90.452 17.927 C 90.452 17.927 90.452 17.827 90.452 17.827 C 90.352 17.727 90.252 17.627 90.252 17.527 L 81.252 8.527 C 80.452 7.727 79.252 7.727 78.452 8.527 C 77.652 9.327 77.652 10.527 78.452 11.327 L 84.052 16.927 L 76.052 16.927 C 70.052 16.927 64.252 19.427 60.152 23.727 L 50.052 34.427 L 40.052 24.027 C 35.952 19.727 30.152 17.227 24.152 17.227 L 11.252 17.227 C 10.152 17.227 9.252 18.127 9.252 19.227 C 9.252 20.327 10.152 21.227 11.252 21.227 L 15.552 21.227 L 24.152 21.227 C 29.052 21.227 33.752 23.227 37.152 26.827 L 45.052 35.027 L 47.252 37.327 L 37.152 47.927 C 33.752 51.427 29.052 53.527 24.152 53.527 L 11.252 53.527 C 10.152 53.527 9.252 54.427 9.252 55.527 C 9.252 56.627 10.152 57.527 11.252 57.527 L 24.152 57.527 C 30.152 57.527 35.952 55.027 40.052 50.727 L 50.052 40.327 L 60.052 50.727 C 64.152 55.027 69.952 57.527 75.952 57.527 L 83.952 57.527 L 78.352 63.127 C 77.552 63.927 77.552 65.127 78.352 65.927 C 78.752 66.327 79.252 66.527 79.752 66.527 C 80.252 66.527 80.752 66.327 81.152 65.927 L 90.152 56.927 C 90.252 56.827 90.352 56.727 90.352 56.627 C 90.352 56.627 90.352 56.527 90.352 56.527 C 90.452 56.427 90.452 56.327 90.452 56.227 C 90.452 56.227 90.452 56.127 90.452 56.127 C 90.452 56.027 90.552 55.927 90.552 55.827 C 90.552 55.727 90.552 55.527 90.552 55.427 C 90.552 55.327 90.552 55.127 90.552 55.027 C 90.552 54.927 90.552 54.827 90.452 54.727 C 90.452 54.727 90.452 54.627 90.452 54.627 C 90.452 54.527 90.352 54.427 90.352 54.327 C 90.352 54.327 90.352 54.227 90.352 54.227 C 90.252 54.127 90.152 54.027 90.152 53.927 L 81.152 44.927 C 80.352 44.127 79.152 44.127 78.352 44.927 C 77.552 45.727 77.552 46.927 78.352 47.727 L 83.452 52.827 L 83.952 53.327 L 75.952 53.327 C 71.052 53.327 66.352 51.327 62.952 47.727 L 55.052 39.627 L 52.852 37.327 L 62.952 26.727 C 66.352 23.227 71.052 21.127 75.952 21.127 L 83.952 21.127 L 78.352 26.727 C 77.652 27.527 77.652 28.727 78.452 29.527 Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const ArrowLeftIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    className={className}
  >
    <path d="M7.5 0L0.5 6.5L7.5 13L7.5 0Z" fill="white" />
  </svg>
);

export const ArrowRightIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    className={className}
  >
    <path d="M0.5 0L7.5 6.5L0.5 13L0.5 0Z" fill="white" />
  </svg>
);

export const LayersIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6142 2.35688C11.8518 2.21437 12.1485 2.21437 12.386 2.35688L20.386 7.15688C20.6129 7.29306 20.7513 7.53879 20.7501 7.80347C20.7489 8.06815 20.6082 8.31258 20.38 8.44666L12.38 13.1467C12.1455 13.2844 11.8547 13.2844 11.6202 13.1467L3.6202 8.44666C3.39199 8.31258 3.25134 8.06815 3.25012 7.80347C3.2489 7.53879 3.38728 7.29306 3.61424 7.15688L11.6142 2.35688ZM5.46917 7.79321L12.0001 11.6301L18.5311 7.79321L12.0001 3.87464L5.46917 7.79321Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.35699 11.6141C3.5701 11.2589 4.0308 11.1438 4.38599 11.3569L12.0001 15.9254L19.6142 11.3569C19.9694 11.1438 20.4301 11.2589 20.6432 11.6141C20.8563 11.9693 20.7412 12.43 20.386 12.6431L12.386 17.4431C12.1485 17.5856 11.8518 17.5856 11.6142 17.4431L3.61424 12.6431C3.25906 12.43 3.14388 11.9693 3.35699 11.6141Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.35699 15.8141C3.5701 15.4589 4.0308 15.3438 4.38599 15.5569L12.0001 20.1254L19.6142 15.5569C19.9694 15.3438 20.4301 15.4589 20.6432 15.8141C20.8563 16.1693 20.7412 16.63 20.386 16.8431L12.386 21.6431C12.1485 21.7856 11.8518 21.7856 11.6142 21.6431L3.61424 16.8431C3.25906 16.63 3.14388 16.1693 3.35699 15.8141Z"
      fill="white"
    />
  </svg>
);

// Illustration-grade art: served from ui_assets (cached, on-demand)
// instead of inlining tens of KiB of path data into the JS bundle.
export const GoogleSignInButtonSVG = ({ className }) => (
  <img
    className={className}
    src="/ui_assets/icons/google-signin-button.svg"
    width="175"
    height="40"
    alt="Sign in with Google"
  />
);

export const Chevron24Down = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M14.1667 8.3335L10 12.5002L5.83335 8.3335H14.1667Z"
      fill="#DBDBDB"
    />
  </svg>
);

export const Plus20Circle = ({ className, color = 'white' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5898 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM8 -6.99382e-07C3.58172 -1.08564e-06 1.08564e-06 3.58172 6.99382e-07 8C3.13124e-07 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 -3.13124e-07 8 -6.99382e-07Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 12.25C7.58579 12.25 7.25 11.9142 7.25 11.5L7.25 8.75L4.5 8.75C4.08579 8.75 3.75 8.41421 3.75 8C3.75 7.58579 4.08579 7.25 4.5 7.25L7.25 7.25L7.25 4.5C7.25 4.08579 7.58579 3.75 8 3.75C8.41421 3.75 8.75 4.08579 8.75 4.5L8.75 7.25L11.5 7.25C11.9142 7.25 12.25 7.58579 12.25 8C12.25 8.41421 11.9142 8.75 11.5 8.75L8.75 8.75L8.75 11.5C8.75 11.9142 8.41421 12.25 8 12.25Z"
      fill={color}
    />
  </svg>
);

export const QR32Icon = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="white"
      d="M3 9h6V3H3zm1-5h4v4H4zm1 1h2v2H5zm10 4h6V3h-6zm1-5h4v4h-4zm1 1h2v2h-2zM3 21h6v-6H3zm1-5h4v4H4zm1 1h2v2H5zm15 2h1v2h-2v-3h1zm0-3h1v1h-1zm0-1v1h-1v-1zm-10 2h1v4h-1v-4zm-4-7v2H4v-1H3v-1h3zm4-3h1v1h-1zm3-3v2h-1V3h2v1zm-3 0h1v1h-1zm10 8h1v2h-2v-1h1zm-1-2v1h-2v2h-2v-1h1v-2h3zm-7 4h-1v-1h-1v-1h2v2zm6 2h1v1h-1zm2-5v1h-1v-1zm-9 3v1h-1v-1zm6 5h1v2h-2v-2zm-3 0h1v1h-1v1h-2v-1h1v-1zm0-1v-1h2v1zm0-5h1v3h-1v1h-1v1h-1v-2h-1v-1h3v-1h-1v-1zm-9 0v1H4v-1zm12 4h-1v-1h1zm1-2h-2v-1h2zM8 10h1v1H8v1h1v2H8v-1H7v1H6v-2h1v-2zm3 0V8h3v3h-2v-1h1V9h-1v1zm0-4h1v1h-1zm-1 4h1v1h-1zm3-3V6h1v1z"
    />
    <path fill="none" d="M0 0h24v24H0z" />
  </svg>
);

export const ChatbotIcon = ({ className }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2928 5.38251V4.33735C10.1694 4.28971 10.0497 4.2324 9.93473 4.16592C9.4847 3.89088 9.14576 3.45838 8.97977 2.94738C8.81378 2.43637 8.83182 1.88095 9.0306 1.38251C9.14106 1.11069 9.30156 0.863438 9.50326 0.654398C9.70434 0.447336 9.94274 0.282662 10.2051 0.169606C10.4694 0.0564074 10.7531 -0.00125036 11.0394 2.05619e-05C11.4695 -4.18633e-05 11.89 0.131289 12.2476 0.377388C12.6052 0.623487 12.8838 0.973288 13.0482 1.38251C13.2677 1.92967 13.2677 2.5441 13.0482 3.09126C12.9388 3.36313 12.7781 3.60998 12.5755 3.81753L12.5648 3.82859C12.4373 3.9577 12.2955 4.07092 12.1423 4.16592C12.0286 4.23499 11.9087 4.29241 11.7842 4.33735V5.38251H16.8831C17.6149 5.38494 18.316 5.68544 18.8333 6.21837C19.3506 6.75129 19.642 7.47333 19.6439 8.22675V8.64887H20.5892C20.9642 8.65033 21.3234 8.80447 21.5884 9.07765C21.8534 9.35083 22.0026 9.72085 22.0036 10.1069V13.4931C22.0026 13.8792 21.8534 14.2492 21.5884 14.5224C21.3234 14.7956 20.9642 14.9497 20.5892 14.9512H19.6493V15.3327C19.6469 16.087 19.3546 16.8096 18.8362 17.3425C18.3179 17.8755 17.6157 18.1755 16.8831 18.177H9.88818L5.69515 21.8839C5.64893 21.9248 5.5953 21.9558 5.53737 21.9753C5.47944 21.9947 5.41834 22.0022 5.3576 21.9972C5.29686 21.9922 5.23767 21.9749 5.18345 21.9463C5.12923 21.9177 5.08104 21.8783 5.04167 21.8304C4.96292 21.7359 4.92253 21.6138 4.92887 21.4894L5.15267 18.1714H5.11507C4.38424 18.1695 3.68386 17.8699 3.16692 17.338C2.64997 16.8061 2.35848 16.0852 2.35612 15.3327V14.9512H1.41618C1.04088 14.9502 0.681214 14.7963 0.415833 14.523C0.150453 14.2498 0.000945353 13.8795 0 13.4931L0 10.1069C0.000943085 9.72085 0.150205 9.35083 0.415199 9.07765C0.680193 8.80447 1.0394 8.65033 1.41439 8.64887H2.35612V8.22491C2.35754 7.47182 2.64861 6.74997 3.16566 6.21729C3.6827 5.68461 4.38362 5.38446 5.11507 5.38251H10.2928ZM14.8135 8.7226C15.1449 8.7226 15.4689 8.82379 15.7445 9.01337C16.0201 9.20296 16.2349 9.47242 16.3617 9.78769C16.4885 10.103 16.5217 10.4499 16.4571 10.7845C16.3924 11.1192 16.2328 11.4267 15.9984 11.6679C15.7641 11.9092 15.4655 12.0736 15.1404 12.1401C14.8153 12.2067 14.4784 12.1725 14.1722 12.042C13.866 11.9114 13.6043 11.6902 13.4201 11.4065C13.236 11.1228 13.1377 10.7892 13.1377 10.4479C13.1377 9.99036 13.3143 9.55151 13.6285 9.22794C13.9428 8.90438 14.369 8.7226 14.8135 8.7226ZM7.1901 8.7226C7.52154 8.7226 7.84554 8.82379 8.12112 9.01337C8.3967 9.20296 8.61149 9.47242 8.73833 9.78769C8.86516 10.103 8.89835 10.4499 8.83369 10.7845C8.76903 11.1192 8.60942 11.4267 8.37506 11.6679C8.1407 11.9092 7.8421 12.0736 7.51703 12.1401C7.19196 12.2067 6.85502 12.1725 6.54881 12.042C6.2426 11.9114 5.98088 11.6902 5.79674 11.4065C5.61261 11.1228 5.51432 10.7892 5.51432 10.4479C5.51432 9.99036 5.69088 9.55151 6.00515 9.22794C6.31942 8.90438 6.74566 8.7226 7.1901 8.7226ZM8.33236 14.5032C8.30708 14.4827 8.28424 14.4592 8.26432 14.4332C8.2063 14.3631 8.17343 14.2746 8.17122 14.1825C8.1696 14.0899 8.19865 13.9996 8.25358 13.9263C8.27409 13.8996 8.29753 13.8755 8.32341 13.8544C8.42189 13.7745 8.54298 13.7298 8.66834 13.7272C8.79369 13.7245 8.91647 13.764 9.01807 13.8397C9.32403 14.0882 9.66361 14.2894 10.026 14.4369C10.3383 14.5612 10.6706 14.6238 11.0054 14.6212C11.3444 14.6138 11.6795 14.5452 11.9954 14.4185C12.3622 14.2675 12.7083 14.068 13.0249 13.8249C13.1288 13.752 13.2529 13.7158 13.3785 13.7218C13.5041 13.7277 13.6244 13.7756 13.7214 13.8581C13.7456 13.8811 13.7678 13.9064 13.7876 13.9337C13.8402 14.0085 13.8667 14.0994 13.8628 14.1917C13.8552 14.284 13.8187 14.3713 13.759 14.4406C13.7362 14.4672 13.7104 14.4907 13.682 14.5106C13.2793 14.817 12.8378 15.0651 12.3696 15.2479C11.9384 15.4153 11.4823 15.5045 11.0215 15.5115C10.5601 15.5182 10.1015 15.4382 9.66797 15.2756C9.19017 15.0916 8.74272 14.8329 8.34131 14.5088L8.33236 14.5032ZM16.8813 6.34103H5.11507C4.63006 6.34298 4.16548 6.54233 3.8227 6.89561C3.47991 7.24888 3.28673 7.72739 3.28532 8.22675V15.3327C3.28673 15.8321 3.47991 16.3106 3.8227 16.6639C4.16548 17.0172 4.63006 17.2165 5.11507 17.2185H5.68262C5.80536 17.2279 5.91952 17.2868 6.0003 17.3824C6.08109 17.478 6.12198 17.6026 6.1141 17.7291L5.93506 20.4166L9.39046 17.3549C9.43344 17.3106 9.48454 17.2756 9.54079 17.2518C9.59704 17.2281 9.65731 17.2161 9.7181 17.2166H16.8796C17.3646 17.2147 17.8291 17.0153 18.1719 16.662C18.5147 16.3088 18.7079 15.8303 18.7093 15.3309V8.22491C18.7084 7.72589 18.5155 7.24756 18.173 6.89453C17.8304 6.5415 17.366 6.3425 16.8813 6.34103Z"
      fill="white"
    />
  </svg>
);

export const ScreenshotIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2.25C6.9337 2.25 6.87011 2.27634 6.82322 2.32322C6.77634 2.37011 6.75 2.4337 6.75 2.5C6.75 3.22935 6.46027 3.92882 5.94454 4.44454C5.42882 4.96027 4.72935 5.25 4 5.25H3C2.66848 5.25 2.35054 5.3817 2.11612 5.61612C1.8817 5.85054 1.75 6.16848 1.75 6.5V15.5C1.75 15.8315 1.8817 16.1495 2.11612 16.3839C2.35054 16.6183 2.66848 16.75 3 16.75H10.5C10.9142 16.75 11.25 17.0858 11.25 17.5C11.25 17.9142 10.9142 18.25 10.5 18.25H3C2.27065 18.25 1.57118 17.9603 1.05546 17.4445C0.539731 16.9288 0.25 16.2293 0.25 15.5V6.5C0.25 5.77065 0.539731 5.07118 1.05546 4.55546C1.57118 4.03973 2.27065 3.75 3 3.75H4C4.33152 3.75 4.64946 3.6183 4.88388 3.38388C5.1183 3.14946 5.25 2.83152 5.25 2.5C5.25 2.03587 5.43437 1.59075 5.76256 1.26256C6.09075 0.934375 6.53587 0.75 7 0.75H13C13.4641 0.75 13.9092 0.934375 14.2374 1.26256C14.5656 1.59075 14.75 2.03587 14.75 2.5C14.75 2.83152 14.8817 3.14946 15.1161 3.38388C15.3505 3.6183 15.6685 3.75 16 3.75H17C17.7293 3.75 18.4288 4.03973 18.9445 4.55546C19.4603 5.07118 19.75 5.77065 19.75 6.5V10.5C19.75 10.9142 19.4142 11.25 19 11.25C18.5858 11.25 18.25 10.9142 18.25 10.5V6.5C18.25 6.16848 18.1183 5.85054 17.8839 5.61612C17.6495 5.3817 17.3315 5.25 17 5.25H16C15.2707 5.25 14.5712 4.96027 14.0555 4.44454C13.5397 3.92882 13.25 3.22935 13.25 2.5C13.25 2.4337 13.2237 2.37011 13.1768 2.32322C13.1299 2.27634 13.0663 2.25 13 2.25H7Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26152 6.82402C10.0379 6.66807 10.8436 6.76187 11.5634 7.09198C12.2831 7.42209 12.8799 7.97156 13.2682 8.66166C13.6565 9.35176 13.8164 10.1471 13.725 10.9336C13.6772 11.345 13.3048 11.6398 12.8934 11.592C12.482 11.5442 12.1872 11.1718 12.235 10.7604C12.2899 10.2885 12.1939 9.81128 11.961 9.39722C11.728 8.98316 11.3699 8.65348 10.9381 8.45542C10.5062 8.25735 10.0227 8.20107 9.55694 8.29464C9.09114 8.38821 8.66691 8.62683 8.34505 8.9763C8.02319 9.32577 7.82021 9.76816 7.7652 10.2401C7.71019 10.712 7.80598 11.1892 8.03883 11.6033C8.27169 12.0175 8.62966 12.3472 9.06145 12.5454C9.49324 12.7436 9.97669 12.8001 10.4425 12.7066C10.8486 12.6252 11.2439 12.8884 11.3254 13.2945C11.4068 13.7006 11.1436 14.0959 10.7375 14.1774C9.9611 14.3331 9.15535 14.239 8.4357 13.9087C7.71605 13.5784 7.11943 13.0287 6.73134 12.3385C6.34325 11.6483 6.18361 10.8529 6.27529 10.0664C6.36697 9.27988 6.70527 8.54257 7.2417 7.96012C7.77814 7.37767 8.48519 6.97997 9.26152 6.82402Z"
      fill="white"
    />
    <path
      d="M13.4697 20.0303C13.7626 20.3232 14.2374 20.3232 14.5303 20.0303L18.25 16.3107V19C18.25 19.4142 18.5858 19.75 19 19.75C19.4142 19.75 19.75 19.4142 19.75 19V14.5C19.75 14.0858 19.4142 13.75 19 13.75H14.5C14.0858 13.75 13.75 14.0858 13.75 14.5C13.75 14.9142 14.0858 15.25 14.5 15.25H17.1893L13.4697 18.9697C13.1768 19.2626 13.1768 19.7374 13.4697 20.0303Z"
      fill="white"
    />
  </svg>
);

export const Object24Icon = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="text-white"
  >
    <path
      d="M1.3335 8.66667L12.0002 2L22.6668 8.66667V19.3333L12.0002 26L1.3335 19.3333V8.66667L12.0002 14.5333V26V14.5333L22.6668 8.66667"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Object24IconCyan = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3335 8.66667L12.0002 2L22.6668 8.66667V19.3333L12.0002 26L1.3335 19.3333V8.66667L12.0002 14.5333V26V14.5333L22.6668 8.66667"
      stroke="#00FFFF"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Layers-panel icon for primitive-geometry entities (#1999): basic 2D
// shapes, distinct from the wireframe cube that marks 3D-model rows.
export const Geometry24Icon = () => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2.5"
      y="4.5"
      width="11.5"
      height="11.5"
      rx="1"
      stroke="#00FFFF"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <circle cx="15.5" cy="18.5" r="6" stroke="#00FFFF" strokeWidth="2.5" />
  </svg>
);

// Illustration-grade art: served from ui_assets (cached, on-demand)
// instead of inlining tens of KiB of path data into the JS bundle.
export const SignInMicrosoftIconSVG = () => (
  <img
    src="/ui_assets/icons/microsoft-signin.svg"
    width="215"
    height="41"
    alt="Sign in with Microsoft"
  />
);

export const SignInAppleIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="175"
    height="40"
    viewBox="0 0 175 40"
  >
    <title>Sign in with Apple</title>
    <rect width="175" height="40" rx="20" fill="#000000" />
    <g transform="translate(-13, 0)">
      <path
        d="M43.945 12.639c.636-.78 1.066-1.847 1.066-2.915 0-.149-.013-.298-.04-.42-.998.04-2.198.675-2.916 1.522-.567.648-1.079 1.712-1.079 2.793 0 .163.027.326.04.379.067.013.175.027.283.027.905 0 2.024-.608 2.646-1.386zm.756 1.67c-1.469 0-2.713.893-3.469.893-.796 0-1.914-.838-3.15-.838-2.39 0-4.817 1.994-4.817 5.762 0 2.347.905 4.831 2.023 6.44.958 1.386 1.806 2.522 3.031 2.522 1.186 0 1.703-.797 3.166-.797 1.49 0 1.833.77 3.152.77 1.28 0 2.157-1.258 2.983-2.494.918-1.413 1.307-2.794 1.32-2.862-.08-.027-2.618-1.08-2.618-4.017 0-2.509 1.954-3.644 2.076-3.738-1.32-1.915-3.329-1.941-3.697-1.941z"
        fill="#FFFFFF"
      />
      <text
        x="58"
        y="25"
        fill="#FFFFFF"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontSize="13"
        fontWeight="500"
      >
        Sign in with Apple
      </text>
    </g>
  </svg>
);

// Layers-panel icon for the `viewer-start` entity: a ring carrying a play
// triangle — the scene's start view (where visitors open it and where a
// viewer session starts: hotspot tour, look-around, future spawn roles).
export const ViewerStartIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10.5" stroke="#00FFFF" strokeWidth="1.8" />
    <path d="M9.2 7.4V16.6L16.4 12L9.2 7.4Z" fill="#00FFFF" />
  </svg>
);
